import React, { useState, useEffect, useContext } from "react";
import * as yup from "yup";
import styles from "./map.module.css";
import { CountryCodes } from "utils/country_code";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Modal, Button, Row, Col, Nav } from "react-bootstrap";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";
import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox/policy_checkbox";
import { BookingDataContext } from "containers/data_context";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function TravelAgent({ member, setMember }) {
  const { channelId } = useContext(BookingDataContext);
  const [toast, setToast] = useState({ text: null, type: null });
  const [countryOptions, setCountryOptions] = useState([]);
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);
  const [isToastShown, setIsToastShown] = useState(false);
  const [response, setResponse] = useState(null);
  const [activeTab, setActiveTab] = useState("welcome");
  const data = JSON.parse(localStorage.getItem("userInfo"));
  const loginSchema = yup.object({
    phoneNumber: yup.number().typeError("Phone Number must be numeric").required(),
    Email: yup
      .string()
      .required("Valid email is required.")
      .email("Please enter a valid email address."),
  });
  const getSchema = yup.object({
    Name: yup
      .string()
      .required("Full name is required")
      .test(
        "is-valid-name",
        "Full name should contain both first and last names separated by a space",
        (value) => {
          if (!value) return false; // If value is empty, validation fails
          const names = value.trim().split(" ");
          return names.length === 2; // Check if there are exactly two names
        },
      ),
    phoneNumber: yup.number().typeError("Phone Number must be numeric").required(),
    country: yup.string().required(),
    Email: yup
      .string()
      .required("Valid email is required.")
      .email("Please enter a valid email address."),
    Address: yup.string().required(),
    headQuarter: yup.string().required(),
    Activity: yup.string().required(),
    vatNo: yup.string().required(),
    taxOffice: yup.string().required(),
    postalCode: yup.string().required(),
  });

  useEffect(() => {
    const newCountryOptions = Object.keys(CountryCodes).map((countryName) => ({
      code: CountryCodes[countryName],
      name: countryName,
    }));
    setCountryOptions(newCountryOptions);
  }, []);

  useEffect(() => {
    if (toast.text && !isToastShown) {
      setIsToastShown(true);
    }
  }, [toast, isToastShown, data]);

  const handleAgentSubmit = async (values, { setSubmitting }) => {
    await becomeMember(values);

    setSubmitting(false);
  };
  const handleLoginSubmit = async (values, { setSubmitting }) => {
    await loginAgent(values);
    setSubmitting(false);
  };

  const handleModalClose = () => {
    setMember(false);
    setToast({ text: null, type: null });
    setIsPolicyAccepted(false);
  };

  const becomeMember = async (values) => {
    const data = await ApiActions.getTravelAgent(values, channelId);
    setResponse(data);

    if (data?.status === 403) {
      setToast({ text: "Invalid Credentials!", type: "error" });
    } else if (data?.status === 409) {
      setToast({ text: "Response Already submitted with this email", type: "error" });
    } else {
      setToast({ text: "Agent Added!", type: "success" });
    }
  };
  const loginAgent = async (values) => {
    const data = await ApiActions.getTravelAgentDiscount(
      values.Email,
      values.phoneNumber,
      channelId,
    );
    setResponse(data);

    if (data?.status === 404) {
      setToast({
        text: "You are not a agent, Please first become a agent to get discount",
        type: "error",
      });
    } else {
      const agentData = {
        id: data?.data?.id,
        name: data?.data?.name,
        email: data?.data?.email,
        discount: data?.data?.discount,
        country_code: data.data?.country,
        phone: values.phoneNumber,
        login_type: "agent",
        channelId: channelId,
        email_verified: data?.data?.email_verified,
      };
      if (!agentData?.email_verified) {
        await ApiActions.verifyAgent(agentData?.id);
        setToast({
          text: "Ops your email is not verified,Please verfiy to enjoy membership perks.",
          type: "warning",
        });
        return;
      }
      localStorage.setItem("userInfo", JSON.stringify(agentData));
      window.dispatchEvent(new Event("storage"));
      setToast({ text: "agent logined Successfully", type: "success" });
    }
  };

  useEffect(() => {
    if (isToastShown) {
      setTimeout(() => {
        setMember(false);
        setIsPolicyAccepted(false);
        setToast({ text: null, type: null });
        setActiveTab("welcome");
      }, 3000);
    }
  }, [isToastShown, setMember, response]);

  return (
    member && (
      <>
        <Modal show={member} onHide={handleModalClose} centered>
          <Modal.Header>
            <Modal.Title className={styles.title}> Travel Agents</Modal.Title>
            <CloseCircleOutlined
              style={{ fontSize: 20, cursor: "pointer" }}
              onClick={handleModalClose}
            />
          </Modal.Header>
          <Modal.Body>
            <Nav variant="tabs" activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
              {(!data || data?.channelId !== channelId) && (
                <Nav.Item>
                  <Nav.Link eventKey="login">Login</Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item>
                <Nav.Link eventKey="welcome">Register Travel Agents</Nav.Link>
              </Nav.Item>
            </Nav>

            {activeTab === "login" && (
              <Formik
                initialValues={{
                  Email: "",
                  phoneNumber: "",
                }}
                validationSchema={loginSchema}
                onSubmit={handleLoginSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <Row>
                      <Col>
                        <label className={styles.label}>Phone Number:</label>
                        <Field type="tel" name="phoneNumber" className={styles.input} />
                        <ErrorMessage name="phoneNumber" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}>Email:</label>
                        <Field type="email" name="Email" className={styles.input} />
                        <ErrorMessage name="Email" component="div" className={styles.error} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className={styles.btngroup}>
                          <PolicyCheckbox value={isPolicyAccepted} onChange={setIsPolicyAccepted} />
                        </div>
                      </Col>
                    </Row>

                    <div className={styles.btngroup}>
                      <Button
                        type="submit"
                        disabled={isSubmitting || !isPolicyAccepted}
                        className={`${styles.submitbtn} ${
                          isSubmitting || !isPolicyAccepted ? styles.disabled : styles.enabled
                        }`}
                      >
                        Submit
                      </Button>

                      <Button
                        className={styles.cancelbtn}
                        disabled={isSubmitting}
                        onClick={() => {
                          setMember(false);
                          setIsPolicyAccepted(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
            {activeTab === "welcome" && (
              <Formik
                initialValues={{
                  Email: "",
                  Name: "",
                  Address: "",
                  taxOffice: "",
                  vatNo: "",
                  Activity: "",
                  phoneNumber: "",
                  country: "",
                  headQuarter: "",
                  postalCode: "",
                }}
                validationSchema={getSchema}
                onSubmit={handleAgentSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <Row>
                      <Col>
                        <label className={styles.label}>Full Name:</label>
                        <Field type="text" name="Name" className={styles.input} />
                        <ErrorMessage name="Name" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}>Email:</label>
                        <Field type="email" name="Email" className={styles.input} />
                        <ErrorMessage name="Email" component="div" className={styles.error} />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label className={styles.label}>Phone Number:</label>
                        <Field type="tel" name="phoneNumber" className={styles.input} />
                        <ErrorMessage name="phoneNumber" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}>Country:</label>
                        <Field as="select" name="country" className={styles.input}>
                          <option value="">Select Country</option>
                          {countryOptions.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage name="country" component="div" className={styles.error} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <label className={styles.label}>Address :</label>
                        <Field type="text" name="Address" className={styles.input} />
                        <ErrorMessage name="Address" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}>Tax Office :</label>
                        <Field type="text" name="taxOffice" className={styles.input} />
                        <ErrorMessage name="taxOffice" component="div" className={styles.error} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <label className={styles.label}>Zip :</label>
                        <Field type="text" name="postalCode" className={styles.input} />
                        <ErrorMessage name="postalCode" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}> Vat No:</label>
                        <Field type="text" name="vatNo" className={styles.input} />
                        <ErrorMessage name="vatNo" component="div" className={styles.error} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <label className={styles.label}>Activity :</label>
                        <Field type="text" name="Activity" className={styles.input} />
                        <ErrorMessage name="Activity" component="div" className={styles.error} />
                      </Col>
                      <Col>
                        <label className={styles.label}>Head Quarter :</label>
                        <Field type="text" name="headQuarter" className={styles.input} />
                        <ErrorMessage name="headQuarter" component="div" className={styles.error} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className={styles.btngroup}>
                          <PolicyCheckbox value={isPolicyAccepted} onChange={setIsPolicyAccepted} />
                        </div>
                      </Col>
                    </Row>

                    <div className={styles.btngroup}>
                      <Button
                        type="submit"
                        disabled={isSubmitting || !isPolicyAccepted}
                        className={`${styles.submitbtn} ${
                          isSubmitting || !isPolicyAccepted ? styles.disabled : styles.enabled
                        }`}
                      >
                        Submit
                      </Button>

                      <Button
                        className={styles.cancelbtn}
                        disabled={isSubmitting}
                        onClick={() => {
                          setMember(false);
                          setIsPolicyAccepted(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </Modal.Body>
        </Modal>

        {isToastShown && (
          <MyToast
            text={toast.text}
            type={toast.type}
            show={toast.text !== null}
            setShow={() => setToast({ text: null, type: null })}
          />
        )}
      </>
    )
  );
}
